module.exports = __webpack_public_path__ + "img/width-medium@2x.4c0fab8.webp";